import { PracticeBatterSingleSessionPitchLocationChartConfigDto, PitchLocationChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import useReportStore from 'hooks/SessionReport/Pitcher/reportStore';
import PitchLocationChart from 'components/Charts/PitchLocationChart/PitchLocationChart';
import { hitTypes, pitchTypeGroups, pitchTypes } from 'utilities/constants';
import {
  hitTypeToColor,
  hitTypeToTextColor,
  pitchTypeGroupTextToColor,
  pitchTypeGroupToColor,
  pitchTypeToColor,
  pitchTypeToTextColor,
} from 'utilities/colorHelpers';

function getGroupLabelColor(groupLabel: string) {
  return pitchTypeToColor[groupLabel] ?? pitchTypeGroupToColor[groupLabel] ?? hitTypeToColor[groupLabel];
}

function getGroupLabelTextColor(groupLabel: string) {
  return pitchTypeToTextColor[groupLabel] ?? pitchTypeGroupTextToColor[groupLabel] ?? hitTypeToTextColor[groupLabel];
}

const PracticeBatterSingleSessionPitchLocationChart = ({
  chartData,
  isLoading,
  chartConfig,
}: ChartProps<PitchLocationChartDataDto, PracticeBatterSingleSessionPitchLocationChartConfigDto>) => {
  const { selectedConfgValues } = useReportStore();

  const groupLabelsToSimulate =
    chartConfig.grouping === 'PitchTypeOrGroup' ? (selectedConfgValues.pitchGrouping === 'Types' ? pitchTypes : pitchTypeGroups) : hitTypes;

  return (
    <PitchLocationChart
      chartData={chartData?.datasets}
      basePlateOrientation={'BatterSide'}
      showStrikeZoneGrid={true}
      groupLabelsToSimulate={groupLabelsToSimulate}
      getGroupLabelColor={getGroupLabelColor}
      getGroupLabelTextColor={getGroupLabelTextColor}
      isLoading={isLoading}
    />
  );
};

export default PracticeBatterSingleSessionPitchLocationChart;
